<section id="Section{{index}}" restoreScrollPosition [ngClass]="{'section-pair':index%2!==0,'section-impair':index%2===0}" *ngIf="sectionRendered.active">
  <ng-content></ng-content>
</section>
